import { AutogenModelDistanceControl, AutogenRowDistanceControl } from "./autogen/AutogenModelDistanceControl";

export class ModelDistanceControl extends AutogenModelDistanceControl<RowDistanceControl> {
    constructor() {
        super(RowDistanceControl);
    }
}

export class RowDistanceControl extends AutogenRowDistanceControl {
}